<!--
 * @Author: 莫靓仔
 * @Date: 2020-08-20 15:13:10
 * @LastEditTime: 2021-08-26 14:35:25
 * @LastEditors: pzf
 * @Description: 多选人员组件的封装
-->
<template> 
    <div class="drawer-container drawer-wrap-group">
        <section class="member-chose-box drawer-body-group"> 
            <div class="drawer-title">
                选择推送人员
            </div>
            <div class="search-box-panel">
                <van-field class="keyword" v-model="searchValue" placeholder="请输入姓名" size="mini">
                    <img
                        @click="search"
                        slot="right-icon"
                        class="searchIcon"
                        src="@/assets/images/icon_serch.png"
                    />
                </van-field>
            </div> 
            <div class="list-box" v-loading="loading" v-if="!noData">
                <van-collapse accordion v-for="(item, idx) in list" :key="idx" v-model="activeArr">
                    <van-collapse-item
                        v-if="item.userInfos && item.userInfos instanceof Array && item.userInfos.length > 0"
                        :name="item.showName"
                    >
                        <template slot="title">
                            <!-- indeterminate代表不确定性 -->
                            <div class="item_title">
                                <van-checkbox  v-model="item.check"
                                    @change="allCheck(item)">
                                    <template #icon> 
                                        <img class="img-icon" :src="iconImg(item, true)" />
                                    </template> 
                                </van-checkbox> 
                                <span class="title-value">{{ item.departMentName }}</span>
                                <span class="title-number">（{{ item.userInfos.length }}）</span>
                            </div> 
                        </template>
                        <div v-for="(groupItem, groupIdx) in item.userInfos" :key="groupIdx" class="radio-item"> 
                            <van-checkbox v-model="groupItem.check" @change="checkItem(groupItem)">
                                <template #icon> 
                                    <img class="img-icon" :src="iconImg(groupItem)" />
                                </template>  
                                <div class="item-msg">
                                    <div class="item-msg-name">{{ groupItem.name }}</div>
                                    <div class="item-msg-phone" v-if="groupItem.phoneNum">{{ groupItem.phoneNum }}</div>
                                </div> 
                            </van-checkbox>  
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div v-if="noData" class="no-data">没有找到数据！</div> 
        </section> 
        <div class="pop_footer">
            <div class="clearBtn" @click="$_cancel">
                <span>清除选项</span>
            </div>
            <div class="confirm" @click="save">
                <span>确认</span
                ><span class="checked-type" v-if="selectItem.length"
                    >（已选{{ selectItem.length }}个）</span
                >
            </div>
        </div>
    </div> 
</template>

<script>
import { mapState } from 'vuex'
import $axios from 'axios'
export default {
    name: 'memberChoseDrawer',
    props: ['assistantList' ],
    components: {},
    data() {
        return {
            memberValue: '',
            searchValue: '',
            defaultImgurl: require('@/assets/images/icon_Avatar.png'),
            // 列表数据
            list: [],
            selectItem: [],
            loading: false,
            // el-collapse 控制是否展开的一个数组
            activeArr: [],
            noData: false,
            source: null,
            activeIcon: require('@/assets/images/vant/icon_sel_pre@2x.png'),
            inactiveIcon: require('@/assets/images/vant/icon_sel_nor@2x.png'),
            indeterminate: require('@/assets/images/vant/icon_sel@2x.png')
        }
    },
    computed: { 
    },
    mounted() {
        if (this.assistantList && this.assistantList.length) {
            this.selectItem = JSON.parse(JSON.stringify(this.assistantList))
            this.selectItem.forEach(item => {
                item.check = true // 设置默认值
            })
        } 
        this.getAfterSaleList()
    },
    methods: { 
        //清空
        $_cancel() {
            this.list.forEach(item => { 
                this.$set(item, 'checkNum', 0)  
                this.$set(item, 'check', false)  
                item.userInfos.forEach(mtm => {
                    this.$set(mtm, 'check', false)  
                })
            })
            this.selectItem = []
        },
        // 是否全选的样式
        iconImg (item, indeterminate) {   
            if (item.check || !indeterminate) { 
                return item.check ? this.activeIcon : this.inactiveIcon
            } else {
                return item.checkNum === 0 ? this.inactiveIcon : this.indeterminate
            } 
        },
        cancelQuest() {
            if (typeof this.source === 'function') {
                this.source('my-cancel') //取消请求
            }
        },
        search() {
            if (this.list.every(item => item.userInfos && item.userInfos.length <= 0)) {
                this.noData = true
            } else {
                this.noData = false
            }
            this.getAfterSaleList(true)
        },
        /**
         * @description:
         * @param {boolean} showList 是否展开列表，搜索之后要展开列表
         * @return {type}
         */
        getAfterSaleList(showList) {
            return new Promise((resolve, reject) => {
                this.cancelQuest()
                this.loading = true
                const _this = this 
                let appId = localStorage.getItem(location.host + 'appId')
                let token = localStorage.getItem(location.host + 'token');
                this.$http
                    .get(`/dc/${appId}/um/department/member`, {
                        params: {
                            keyWord: this.searchValue,
                            token: token, 
                            limit: 0,
                            recent: false,
                            origin: 1 //  请求来源，1是web，
                        },
                        cancelToken: new $axios.CancelToken(function executor(c) {
                            _this.source = c
                        })
                    })
                    .then(res => {
                        this.activeArr = []
                        res.forEach((item, idx) => {
                            item.showName = idx + '-' + item.name
                            // searchValue为空的时候就是选择了全部，相当于初始化，不必展开
                            if (showList && this.searchValue !== '') {
                                this.activeArr.push(item.showName)
                            }
                        })
                        this.list = res.filter(item => {
                            return item.userInfos && item.userInfos.length
                        })
                        if (this.list.every(item => item.userInfos && item.userInfos.length <= 0)) {
                            this.noData = true
                        } else {
                            this.noData = false
                        }
                        this.loading = false
                        this.getDefaltValue(this.list)
                    })
                    .catch(err => {
                        this.loading = false
                        reject(err)
                    })
            })
        }, 
        // 完成
        save() { 
            let uids = []
            if (this.selectItem && this.selectItem.length) {
                this.selectItem.forEach(item => {
                    uids.push(item.uid)
                })
            } else {
                uids = []
            }
            this.$emit('save', this.selectItem)
        },
        unique(arr, u_key) {
            // 去重并且获取勾选的
            let map = new Map()
            arr.forEach((item, index) => {
                if (!map.has(item[u_key]) && item.check) {
                    map.set(item[u_key], item)
                }
            })
            return [...map.values()]
        },
        // 全选
        allCheck(item, flag) {
            if (flag) {
                item.check = true
            }
            item.userInfos.forEach(mtm => {
                mtm.check = item.check
                // 同步更改相关内容
                this.syncOtherItem(mtm)
            })
            item.checkNum = item.check ? item.userInfos.length : 0
            this.checkItem()
        },
        syncOtherItem(obj) {
            this.list.forEach(item => {
                item.userInfos.forEach(mtm => {
                    if (mtm.uid === obj.uid) {
                        mtm.check = obj.check
                    }
                })
            })
        },
        checkItem(obj) { 
            // 同步更改相关内容
            obj && this.syncOtherItem(obj)
            // 每次更改同步数据
            // this.selectItem = []
            this.list.forEach(item => {
                item.userInfos.forEach(mtm => {
                    let flag = false // 判断列表中是否有选中的元素
                    this.selectItem.forEach(item => {
                        if (item.uid === mtm.uid) {
                            flag = true
                            item.check = mtm.check
                        }
                    })
                    if (mtm.check && !flag) {
                        // 没有就推入
                        this.selectItem.push(mtm)
                    }
                })
            })
            this.selectItem = this.unique(this.selectItem, 'uid') // 去重，去掉check为false的
            // 同步勾选状态
            this.setAllCheck(this.list)
        },
        getDefaltValue(arr) {
            arr.forEach(item => {
                item.userInfos.forEach(mtm => {
                    // 初始化check
                    let flag = false
                    if (this.selectItem && this.selectItem.length) {
                        this.selectItem.forEach(assistant => {
                            if (assistant.uid === mtm.uid) {
                                flag = assistant.check
                            }
                        })
                    }
                    this.$set(mtm, 'check', flag) 
                })
            })
            // 初始化全选状态
            this.setAllCheck(arr)
        },
        setAllCheck(arr) {
            arr.forEach(item => {
                // 判断无选中
                let isCheckArr = item.userInfos.filter(mtm => {
                    return mtm.check
                })
                item.checkNum = isCheckArr.length
                item.check = isCheckArr.length === item.userInfos.length ? true : false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin';
// 抽屉
.drawer-wrap-group {
    display: flex;
    flex-direction: column;
    height: 100%;

    .drawer-body-group {
        flex: 1;
        overflow-y: auto;
    }

    .drawer-button-group {
        // 底部操作按钮
        width: 100%;
        height: vw(44);
        line-height: vw(44);     
    }
    .pop_footer {
        @include fr;  
        height: vw(44);
        width: 100%;
        .clearBtn {
            border: vw(1) solid #ccc;
            background-color: #fff;
            width: 44vw;
            @include fja;
            span {
                @include sc(vw(17), #666);
            }
            // cursor: pointer;
            // -webkit-tap-highlight-color: transparent;
        }
        .clearBtn:active {
            opacity: 0.5;
        }
        .confirm {
            background-color: #3766e1;
            width: 56vw;
            @include fja;

            span {
                @include sc(vw(17), #fff);
            }
        }
        .confirm:active {
            opacity: 0.5;
        }
        .checked-type {
            font-size: vw(14) !important;
        }
    }
}
.drawer-container {
    height: 100%;   
    %flex {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    ::v-deep .img-icon{
        width: vw(24);
        height: vw(24);
    }
    ::v-deep .van-cell { 
        :before {
            border: none
        }
    }
    .member-chose-box {
        padding-top: vw(14);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        .search-box-panel {
            margin: 0 vw(15);
            ::v-deep .van-field__body {
                background-color: #fff;
                border: vw(1) solid #f2f2f2;
                border-radius: vw(18);
                padding: 0;
                padding-left: vw(16);
                height: vw(36);
            }
            ::v-deep .van-field__right-icon {
                height: vw(34);
            }
            .keyword {
                padding: 0;
                .searchIcon {
                    width: vw(49);
                    height: vw(34);
                }
            }
        }
        .drawer-title{
            color: #333333;
            font-size: vw(17);
            padding: 0 vw(15);
            font-weight: 500;
            margin-bottom: vw(15);
        }  
        .list-box {
            padding: vw(20) 0 vw(20) vw(20);
            flex: 1;
            overflow-y: auto;
            .el-collapse {
                border-bottom: 0;
            }
            .item_title{
                display: flex;
            } 
            .title-value {
                margin-left: vw(10);
                font-size: vw(16);
                color: #333;
                font-weight: 500;
                margin-right: vw(10);
            }
            .title-number {
                font-size: vw(16);
                color: #999;
                font-weight: 500;
            }
            .radio-item { 
                margin-bottom: vw(20);
                ::v-deep .van-checkbox__label{
                    width: 100%;
                }
                .item-msg {  
                    border-bottom: vw(1) solid #EEEEEE;
                    min-height: vw(30); 
                    .item-msg-name,
                    .item-msg-phone {
                        font-size: vw(14);
                        color: #333;
                        font-weight: 500;
                        height: vw(22);
                    }
                    .item-msg-phone {
                        color: #999;
                        line-height: vw(24);
                        height: vw(22);
                    }
                }
            }
        }
        .no-data {
            flex: 1;
            text-align: center;
            font-size: vw(16);
            padding-top: vw(50);
        }
    } 
} 
</style>
